import React, { useState, useContext } from 'react'
import { M_Fieldset, M_InputTextField, LoadingContext, M_Button, BufferService } from '../M_Components'
import { Clear, Done } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import './settings.css'

export const ChangePassword = ({ Email }) => {
    const ctx = useContext(LoadingContext)
    const [values, setValues] = useState(new Map([]))
    const passwordService = new BufferService('identity/updatepassword')
    const { t } = useTranslation()

    const changeValues = (obj, key) => {
        values.set(key, obj)
        setValues(new Map(values))
    }

    const submitPass = () => {
        ctx.setIsLoad(true)
        if (values.get("pass") === values.get("newPass")) {
            ctx.toastMessages('error', t('PasswordcannotSame'), '')
            ctx.setIsLoad(false)
            return
        }
        if (values.get("newPass") !== values.get("confNewPass")) {
            ctx.toastMessages('error', t('NewPasswordNotMatch'), '')
            ctx.setIsLoad(false)
            return
        }
        const tempObj = {
            "email": Email,
            "oldPassword": values.get("pass"),
            "newPassword": values.get("newPass")
        }

        passwordService.update('', tempObj).then(res => {
            ctx.setIsLoad(false)
            if (res.name === 'AxiosError') {
                ctx.toastMessages('error', res.response.data.Errors.toString(), '')
                return
            }
            ctx.toastMessages('success', '', t("SuccessUpdatePassword"))
            setValues(new Map())
        })
    }

    return (
        <div className='divGlobalSettings' data-testid="settings-container">
            <div className='subTitleSettings'>
                <div>
                    <div style={{ color: ctx.secondaryColor }} data-testid="change-password-title">
                        {t('ChangePassword')}
                    </div>
                    <div className='labelSubtitleSettings' data-testid="change-password-info">
                        {t("InfoChangePassword")}
                    </div>
                </div>
            </div>
            <div className='changePrincipalDiv'>
                <div className="full-width">
                    <M_InputTextField
                        label={t("OldPassword")}
                        value={values.get('pass') || ''}
                        type={"password"}
                        onChange={(e) => changeValues(e.target.value, 'pass')}
                        style={{ width: '100%' }}
                    />
                </div>
                <M_InputTextField
                    label={t("NewPassword")}
                    value={values.get('newPass') || ''}
                    type={"password"}
                    onChange={(e) => changeValues(e.target.value, 'newPass')}
                    passVerification
                    minLengthverification={6}
                    valueAgain={values.get('confNewPass')}
                />
                <M_InputTextField
                    label={t("ConfirmPassword")}
                    value={values.get('confNewPass') || ''}
                    type={"password"}
                    onChange={(e) => changeValues(e.target.value, 'confNewPass')}
                />
                <div className='buttonContainer'>
                    <M_Button
                        label={t("ButtonCancel")}
                        icon={<Clear style={{ color: 'var(--color-white)' }} />}
                        backgroundColor={'var(--color-red)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => { setValues(new Map([])) }}
                    />
                    <M_Button
                        label={t("ButtonConfirm")}
                        icon={<Done style={{ color: 'var(--color-white)' }} />}
                        backgroundColor={'var(--color-green)'}
                        labelColor={'var(--color-white)'}
                        onClick={() => { submitPass() }}
                    />
                </div>
            </div>
        </div>
    )
}

ChangePassword.propTypes = {
    Email: PropTypes.string
}
